// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const PaymentWrapper: StatelessFunctionalComponent<*> = styled.div`
  position: relative;

  #custom_modal { overflow-y: auto; }

  .Payment {
    &-message-container {
      padding: 20px;
      }

    &-message-container-image {
      margin: 0 auto;
      padding: 40px 10px 10px;
    }

    &-message-image {
      width: 100%;
    }

    &-text {
      max-width: 440px;
      margin: 0 auto;
      font-size: 18px;
      padding: 20px;
      line-height: 1.5;
      text-align: center;
      color: var(--text-color-2);
    }

    &-text-form {
      max-width: 440px;
      margin: 0 auto;
      font-size: 19.2px;
      padding-top: 20px;
      padding: 5px;
      line-height: 1.5;
      text-align: center;
      color: var(--text-color-2);
    }

    &-button-container {
      cursor: pointer;
      text-align: center;
      margin: 0 auto;
      max-width: 400px;
      color: var(--white-color);
    }

    &-back-button {
      width: 150px;
      height: 32px;
      border-radius: 15.8px;
      background-color: var(--blue-color);
      box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.24);
      font-size: 14px;
      font-weight: 500;
      line-height: 2.3;
      display: inline-block;
      cursor: pointer;
      margin: 10px 0px 20px;
    }
  }

  .Checkout {
    display: flex;
    margin-top: 40px;
    margin-bottom: 40px;

    & > div {
      width: 50%;
      display: flex;
      justify-content: center;
    }
    
    & > div:last-child {
      padding-left: 40px;
      justify-content: flex-start;
    }
    
    &-icon {
      width: 180px;
      height: 180px;
      margin-top: 40px;
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    &-icon img {
      width: 50%;
      height: auto;
    }
    
    &-wrapper h3 {
      color: #525252;
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 40px;
      margin-top: 0;
    }
    
    &-cards {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    &-contract {
      margin: 0;
      margin-top: 35px;
      text-align: right;
    }

    &-installments {
      font-size: 16px;
      padding-top: 20px;
    }

    &-footer {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    
    &-footer p {
      max-width: 420px;
      margin-right: 15px;
      font-size: 15px;
      color: darkblue;
      font-weight: 700;
    }

    @media screen and (max-width: 650px) {
      &-wrapper {
        margin-left: auto;
        margin-right: auto;
      }
      
      &-footer {
        flex-direction: column;
        align-items: flex-end;
      }
    
      &-footer p {
        margin-bottom: 20px;
        font-size: 14px;
      }
    }

    .Card {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
      cursor: pointer;

      &-radio {
        border: 1px solid #ccc;
        border-radius: 50%;
        min-width: 20px;
        min-height: 20px;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      
      &-radio--on:after {
        content: '';
        display: block;
        width: 10px;
        height: 10px;
        background-color: var(--blue-light-color);
        border-radius: 50%;
      }
      
      &-logo {
        height: 100%;
        display: inline-block;
        text-align: left;
        vertical-align: middle;
        font-size: 18px;
      }
      
      &-logo img {
        vertical-align: middle;
      }
      
      &--disabled {
        opacity: .28;
        cursor: default;
      }
      
      &-soon {
        text-transform: uppercase;
        font-size: .85em;
        margin-left: 10px;
      }
    }
  }

  .Debit {
    &-formRow {
      max-width: 450px;
      text-align: center;
      margin: auto !important;
    }

    &-check {
      padding: 20px;
      font-size: 1.4em;

      &-box {
        width: 21px;
        height: 21px;
        display: inline-block;
        background-color: #ffffff;
        vertical-align: middle;
        margin: 0px 12px;
        box-shadow: none !important;
      }

      &-error {
        color: var(--input-error-color) !important;
      }
    }
  }

  .Message {
    &-container {
      display: grid;
      gap: 10px;
      text-align: center;
    }

    &-container-image {
      margin: 0 auto;
      padding-top: 40px;
    }

    &-image {
      width: 90%;
    }

    &-text {
      max-width: 500px;
      margin: 0 auto;
      font-size: 20px;
      padding: 20px;
      line-height: 1.5;
      text-align: center;
      color: var(--text-color-2);
    }

    &-link {
      font-family: var(--font-family-alt);
      margin-top: 15px;
    }

    &-button-container {
      cursor: pointer;
      text-align: center;
      margin: 0 auto;
      max-width: 400px;
      color: var(--white-color);
    }
  }
`;

export default PaymentWrapper;
